/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';
import type { CustomerCenter } from './CustomerCenter';
import {
    CustomerCenterFromJSON,
    CustomerCenterFromJSONTyped,
    CustomerCenterToJSON,
    CustomerCenterToJSONTyped,
} from './CustomerCenter';

/**
 * 
 * @export
 * @interface ResponseCustomerCenter
 */
export interface ResponseCustomerCenter {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseCustomerCenter
     */
    result: ResponseResult;
    /**
     * 
     * @type {CustomerCenter}
     * @memberof ResponseCustomerCenter
     */
    data: CustomerCenter;
}

/**
 * Check if a given object implements the ResponseCustomerCenter interface.
 */
export function instanceOfResponseCustomerCenter(value: object): value is ResponseCustomerCenter {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseCustomerCenterFromJSON(json: any): ResponseCustomerCenter {
    return ResponseCustomerCenterFromJSONTyped(json, false);
}

export function ResponseCustomerCenterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseCustomerCenter {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': CustomerCenterFromJSON(json['data']),
    };
}

export function ResponseCustomerCenterToJSON(json: any): ResponseCustomerCenter {
    return ResponseCustomerCenterToJSONTyped(json, false);
}

export function ResponseCustomerCenterToJSONTyped(value?: ResponseCustomerCenter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': CustomerCenterToJSON(value['data']),
    };
}

